import "core-js/modules/es.array.push.js";
// libs
import { mapState, mapGetters } from 'vuex';

// services
import { AuthService } from '@/services/auth.service';

// components
import PatientIcon from '@/components/icon/PatientIcon';
import DoctorIcon from '@/components/icon/DoctorIcon';
import MessageIcon from '@/components/icon/MessageIcon';
import ChatIcon from '@/components/icon/ChatIcon';
import EarningsIcon from '@/components/icon/EarningsIcon';
import AdminIcon from '@/components/icon/AdminIcon';
import ProfileIcon from '@/components/icon/ProfileIcon';
import IconRouted from '@/components/icon/IconRouted';
import InventoryIcon from '@/components/icon/InventoryIcon';
import { ROLES } from '@/constants/middleware';

// socket
import socket from '@corefront/utils/socket';
export default {
  components: {
    PatientIcon,
    DoctorIcon,
    MessageIcon,
    ChatIcon,
    EarningsIcon,
    IconRouted,
    AdminIcon,
    ProfileIcon,
    InventoryIcon
  },
  data() {
    return {
      currentYear: null,
      intervalFunction: null,
      showSidebar: true
    };
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('auth', ['hasRole']),
    navList() {
      const route = this.$route;
      const navs = [{
        name: 'Patients',
        icon: PatientIcon,
        to: '/',
        is_active: route.name === 'patients',
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER]
      }, {
        name: 'Doctors',
        icon: DoctorIcon,
        to: '/doctors',
        is_active: route.name === 'doctors',
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER]
      }, {
        name: 'Messages',
        icon: MessageIcon,
        to: '/messages',
        is_active: route.name === 'messages',
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER]
      }, {
        name: 'Router',
        icon: IconRouted,
        iconClass: 'tw-text-[25px]',
        to: '/routed-messages',
        is_active: route.name === 'routed-messages',
        roles: [ROLES.SUPER_ADMIN, ROLES.MANAGER]
      }, {
        name: 'Chat',
        icon: ChatIcon,
        to: '/chat',
        hasBadge: true,
        is_active: ['chat', 'chat-id'].includes(route.name),
        roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER]
      }, {
        name: 'Earnings',
        icon: EarningsIcon,
        to: '/earnings',
        is_active: route.name === 'earnings',
        roles: [ROLES.MANAGER]
      }, {
        name: 'Admins',
        icon: AdminIcon,
        to: '/admins',
        is_active: route.name === 'admins',
        roles: [ROLES.MANAGER]
      }, {
        name: 'Inventory',
        icon: InventoryIcon,
        to: '/inventory',
        is_active: route.name === 'inventory',
        roles: [ROLES.SUPER_ADMIN, ROLES.MANAGER]
      }];
      return navs.filter(nav => {
        if (!nav.roles) {
          return true;
        }
        return this.hasRole(nav.roles);
      });
    }
  },
  created() {
    this.$store.dispatch('auth/getUser');
    socket.connect({
      url: process.env.VUE_APP_WEBSOCKET_URL,
      auth: cb => cb({
        token: localStorage.getItem('accessToken')
      })
    });
    socket.ctx.on('error', async error => {
      console.log('error');
      Promise.resolve().then(async () => {
        await AuthService.refreshTokens();
        socket.ctx.auth.token = localStorage.getItem('accessToken');
        socket.connect();
      }).catch(err => {
        console.error('Failed to refresh tokens:', err);
      });
      this.$bvToast.toast(`We're having trouble connecting. Please refresh the page to continue. ${JSON.stringify(error)}`, {
        title: 'Something went wrong',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-bottom-center',
        autoHideDelay: 10000
      });
    });
    socket.ctx.on('connect_error', async error => {
      console.log('connect_error');
      Promise.resolve().then(async () => {
        await AuthService.refreshTokens();
        socket.ctx.auth.token = localStorage.getItem('accessToken');
        socket.connect();
      }).catch(err => {
        console.error('Failed to refresh tokens:', err);
      });
      this.$bvToast.toast(`We're having trouble connecting. Please refresh the page to continue. ${JSON.stringify(error)}`, {
        title: 'Something went wrong',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-bottom-center',
        autoHideDelay: 10000
      });
    });
    socket.ctx.on('validation_error', (type, message, meta) => {
      console.log('validation_error');
      this.$bvToast.toast(JSON.stringify({
        type,
        message,
        meta
      }), {
        title: 'Something went wrong',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-bottom-center',
        autoHideDelay: 10000
      });
    });
    socket.ctx.on('request_error', error => {
      console.log('request_error');
      this.$bvToast.toast(`We're having trouble connecting. Please refresh the page to continue. ${JSON.stringify(error)}`, {
        title: 'Something went wrong',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-bottom-center',
        autoHideDelay: 10000
      });
    });
    socket.ctx.on('disconnect', reason => {
      if (reason === 'io server disconnect') {
        this.$bvToast.toast('Please refresh the page.', {
          title: 'Something went wrong',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 10000
        });
      }
    });
  },
  mounted() {
    const year = new Date().getFullYear();
    this.currentYear = year;
  },
  destroyed() {
    clearInterval(this.intervalFunction);
  },
  methods: {
    async onLogout() {
      await AuthService.logout();
      this.$router.push('/login');
    }
  }
};